<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('weight.title') }}</div>
                    </van-col>
                    <van-col span="6" @click="openSet">
                        <img class="set-icon" :src="require(`@/assets/theme/${theme}/status/20weight/01set.svg`)">
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 2}" @click="changeTimeType(2, $t('dailyActive.time2'))">{{ $t('dailyActive.time2') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{ time }}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                <div class="chart-unit">kg</div>
            </div>
            <div id="chart-box"></div>
        </div>
        <div class="bmi-box">
            <div class="bim-title">BMI</div>
            <div class="bim-height" @click="showHeightSet=true">
                <img class="height-icon"
                     :src="require(`@/assets/theme/${theme}/status/20weight/03height.svg`)">
                {{ $t('weight.height') }}<span class="height-value">{{this.height}}cm</span>
            </div>
            <div class="bim-value-box">
                <span class="bim-value">{{selectBmi?selectBmi:'--'}}</span>
                <span class="bim-level level0" v-if="selectBmi>0&&selectBmi<18.5">{{selectBmiLevel}}</span>
                <span class="bim-level level1" v-else-if="selectBmi<=23.9">{{selectBmiLevel}}</span>
                <span class="bim-level level2" v-else-if="selectBmi<30">{{selectBmiLevel}}</span>
                <span class="bim-level level3" v-else="selectBmi>=30">{{selectBmiLevel}}</span>
            </div>
            <div class="bim-process-box">
                <div class="bim-process-bar bar0"></div>
                <div class="bim-process-bar bar1"></div>
                <div class="bim-process-bar bar2"></div>
                <div class="bim-process-bar bar3"></div>
                <img class="bar-icon" v-if="selectBmi" :style="{'left': barLeft + 'px'}" :src="require(`@/assets/theme/${theme}/status/20weight/02bar.svg`)">
            </div>
        </div>
        <div class="math-box">
            <van-row>
                <van-col span="6">
                    <div class="math-item">
                        <div class="math-num">{{ mathData.maxData ? mathData.maxData : '--' }}</div>
                        <div class="math-text">{{ $t('pressure.math0') }}</div>
                    </div>
                </van-col>
                <van-col span="6">
                    <div class="math-item">
                        <div class="math-num">{{ mathData.minData ? mathData.minData : '--' }}</div>
                        <div class="math-text">{{ $t('pressure.math1') }}</div>
                    </div>
                </van-col>
                <van-col span="6">
                    <div class="math-item">
                        <div class="math-num">{{ mathData.avgData ? mathData.avgData : '--' }}</div>
                        <div class="math-text">{{ $t('pressure.math2') }}</div>
                    </div>
                </van-col>
                <van-col span="6">
                    <div class="math-item">
                        <div class="math-num"> {{
                                mathData.maxData && mathData.minData
                                    ? (Number.isInteger(mathData.maxData - mathData.minData)
                                            ? (mathData.maxData - mathData.minData)
                                            : (mathData.maxData - mathData.minData).toFixed(1)
                                    )
                                    : '--'
                            }}</div>
                        <div class="math-text">{{ $t('weight.change') }}</div>
                    </div>
                </van-col>
            </van-row>
        </div>
        <div class="desc-box">
            <div class="desc-title">BMI</div>
            <div class="desc-info desc-last">
                {{ $t('weight.desc0') }}
                <br>
                {{ $t('weight.desc1') }}
                <br>
                {{ $t('weight.desc2') }}
                <br>
                {{ $t('weight.desc3') }}
                <br>
                {{ $t('weight.desc4') }}
                <br>
                {{ $t('weight.desc5') }}
            </div>
        </div>
        <van-popup v-model="showSet" round position="bottom">
            <van-picker
                :key="pickerKey"
                :title="$t('weight.popTitle')"
                show-toolbar
                :columns="columns"
                @cancel="showSet = false"
                @confirm="onConfirm"
            />
        </van-popup>
        <van-popup v-model="showHeightSet" round position="bottom">
            <van-picker
                :key="pickerHeightKey"
                :title="$t('weight.heightPop')"
                show-toolbar
                :columns="columnsHeight"
                :default-index="heightIndex"
                @cancel="showHeightSet = false"
                @confirm="onConfirmHeight"
            />
        </van-popup>
    </div>
</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {
    getToday,
    getNWeekFirstDay,
    getNWeekLastDay,
    getMonthStartDay,
    getMonthEndDay,
    GetDateStr, SwitchTime24,
    changeDate,
    changeMonthDate,
    GetYear
} from "../../utils/dateUtils";
import {getWeightCountList} from "../../api/status";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'pressure',
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            activeTime: 0,
            timeUnit: '',
            time: '',
            startDate: '',
            endDate: '',
            yNum: 0,
            wNum: 0,
            mNum: 0,
            showTimeBox: false,
            pressureInfo: {},
            mathData: {},
            myChart: null,
            pressureRatioChart: null,
            showLeftOpacity: 0,
            showRightOpacity: 1,
            height: '',
            selectBmi: '',
            selectBmiLevel: '',
            barLeft: 0,
            showSet: false,
            columns: [
                // ��һ��
                {
                    values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200],
                    defaultIndex: 59
                },
                // �ڶ���
                {
                    values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
                    defaultIndex: 0
                }
            ],
            pickerKey: 0,
            showHeightSet: false,
            columnsHeight: [100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250],
            pickerHeightKey: 0,
            heightIndex: 70,
        }
    },
    watch: {
        showTimeBox: {
            handler(newVal, olVal) {
                if (newVal) {
                    setTimeout(() => {
                        document.addEventListener('click', this.checkClick);
                    }, 0);
                } else {
                    document.removeEventListener('click', this.checkClick);
                }
            }
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.timeUnit = this.$t('weight.time0');
        this.startDate = getNWeekFirstDay(this.wNum);
        this.endDate = getNWeekLastDay(this.wNum);
        this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
        this.getData();
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        checkClick(event) {
            let dom = this.$refs.showContent; // ��������������˵�Ԫ��
            if (!dom.contains(event.target)) {
                // ���ڲ˵���Χ�����ؼ���
                if (this.showTimeBox) {
                    this.showTimeBox = false;
                    document.removeEventListener('click', this.checkClick);
                }
            }
        },
        checkOpacity() {
            if (this.activeTime == 2 && this.yNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 0 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 1 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime == 2 && GetYear(this.yNum - 1) <= 2024) {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 0 && this.startDate <= '2024-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 1 && this.startDate <= '2024-01-01') {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.activeTime == 2 && GetYear(this.yNum - 1) > 2024) {
                this.yNum--;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            } else if (this.activeTime == 0 && this.startDate > '2024-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2024-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            this.getData();
        },
        timeRight() {
            if (this.activeTime == 0 && this.yNum > 0) {
                this.yNum++;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            } else if (this.activeTime == 0 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            this.getData();
        },
        changeTimeType(num, unit) {
            this.activeTime = num;
            this.timeUnit = unit;
            this.showTimeBox = false;
            if (this.activeTime == 0) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 1) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 2) {
                this.time = GetYear(this.yNum);
                this.startDate = GetYear(this.yNum);
            }
            this.getData();
        },
        getData() {
            this.checkOpacity();
            this.mathData = {}
            if (this.activeTime == 2) {
                this.$api.status.getWeightCountYear({
                    year: this.startDate
                }).then(res => {
                    if (res.result == 1) {
                        this.pressureInfo = res.info;
                        this.mathData.maxData = res.info.max;
                        this.mathData.avgData = res.info.avg;
                        this.mathData.minData = res.info.min;
                        this.pressureInfo.dateArr = [];
                        this.pressureInfo.dataArr = [];
                        this.height = res.info.height;
                        this.selectBmi = this.getBmi(this.mathData.avgData);
                        this.getBmiLevel(this.selectBmi)
                        if (this.mathData.avgData) {
                            this.columns[0].defaultIndex = Math.round(this.mathData.avgData) - 1;
                            const decimalPart = Math.floor((this.mathData.avgData - Math.floor(this.mathData.avgData)) * 10);
                            // ���µڶ��е� defaultIndex
                            this.columns[1].defaultIndex = decimalPart;
                            this.pickerKey++;
                        }
                        for (let i = 0; i < this.pressureInfo.weightCountList.length; i++) {
                            this.pressureInfo.dateArr.push(i + 1);
                            let color;
                            let data = this.getBmi(this.pressureInfo.weightCountList[i].value);
                            let weight = this.pressureInfo.weightCountList[i].value;
                            if (data <= 0) {
                                weight = null
                            } else if (data < 18.5) {
                                color = getSkin('--chart-color-24')
                            } else if (data <= 23.9) {
                                color = getSkin('--chart-color-1')
                            } else if (data <= 29.9) {
                                color = getSkin('--chart-color-5')
                            } else {
                                color = getSkin('--chart-color-3')
                            }
                            let style = {
                                value: weight,
                                itemStyle: {
                                    color: color
                                },
                                emphasis: {
                                    itemStyle: {
                                        borderColor: color,
                                        borderWidth: 1.5 * this.ratio,
                                        color: 'transparent'
                                    }
                                }
                            }
                            this.pressureInfo.dataArr.push(style);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            } else {
                this.$api.status.getWeightCountList({
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.pressureInfo = res.info;
                        this.mathData.maxData = res.info.max;
                        this.mathData.avgData = res.info.avg;
                        this.mathData.minData = res.info.min;
                        this.pressureInfo.dateArr = [];
                        this.pressureInfo.dataArr = [];
                        this.height = res.info.height;
                        this.selectBmi = this.getBmi(this.mathData.avgData);
                        this.getBmiLevel(this.selectBmi)
                        if (this.mathData.avgData) {
                            this.columns[0].defaultIndex = Math.round(this.mathData.avgData) - 1;
                            const decimalPart = Math.floor((this.mathData.avgData - Math.floor(this.mathData.avgData)) * 10);
                            // ���µڶ��е� defaultIndex
                            this.columns[1].defaultIndex = decimalPart;
                            this.pickerKey++;
                        }
                        for (let i = 0; i < this.pressureInfo.weightCountList.length; i++) {
                            this.pressureInfo.dateArr.push(this.pressureInfo.weightCountList[i].date);
                            let color;
                            let data = this.getBmi(this.pressureInfo.weightCountList[i].value);
                            let weight = this.pressureInfo.weightCountList[i].value;
                            if (data <= 0) {
                                weight = null
                            } else if (data < 18.5) {
                                color = getSkin('--chart-color-24')
                            } else if (data <= 23.9) {
                                color = getSkin('--chart-color-1')
                            } else if (data <= 29.9) {
                                color = getSkin('--chart-color-5')
                            } else {
                                color = getSkin('--chart-color-3')
                            }
                            let style = {
                                value: weight,
                                itemStyle: {
                                    color: color
                                },
                                emphasis: {
                                    itemStyle: {
                                        borderColor: color,
                                        borderWidth: 1.5 * this.ratio,
                                        color: 'transparent'
                                    }
                                }
                            }
                            this.pressureInfo.dataArr.push(style);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            }
        },
        drawChart() {
            if (!this.myChart) {
                this.myChart = this.$echarts.init(document.getElementById("chart-box"));
            }
            let _this = this
            if (!this.mathData.avgData) {
                this.myChart.setOption({
                    title: {
                        text: this.$t('noData'),
                        x: 'center',
                        y: 76 * this.ratio,
                        textStyle: {
                            fontFamily: 'SF',
                            fontSize: 12 * this.ratio,
                            fontWeight: 'normal',
                            color: getSkin('--text-color-2')
                        }
                    },
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            color: getSkin('--text-color-3'),
                            formatter: function (value) {
                                if (_this.activeTime != 2) {
                                    return changeDate(value)
                                } else {
                                    return value
                                }
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        data: this.pressureInfo.dateArr
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: [0, 0, 0],
                            type: 'bar',
                            symbol: 'none',
                            smooth: false,
                            barWidth: 10,
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            } else {
                let _this = this;
                this.myChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: {
                        type: 'inside'
                    },
                    tooltip: {
                        backgroundColor: getSkin('--bg-color-2'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.value ? item.value : 0;
                            if (value == 0) {
                                return
                            }
                            _this.selectBmi = _this.getBmi(value);
                            _this.getBmiLevel(_this.selectBmi)
                            let html = '';
                            html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + changeDate(item.axisValue) + '</div>'
                            html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span> <span style="font-size:12px;color: ' + getSkin('--text-color-3') + '">kg</span></div>'
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            color: getSkin('--text-color-3'),
                            formatter: function (value) {
                                if (_this.activeTime != 2) {
                                    return changeDate(value)
                                } else {
                                    return value
                                }
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        data: this.pressureInfo.dateArr
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitNumber: 4,
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            color: getSkin('--text-color-3'),
                            showMinLabel: false
                        }
                    },
                    series: [
                        {
                            data: this.pressureInfo.dataArr,
                            type: 'scatter',
                            symbolSize: 6 * this.ratio,
                        }
                    ]
                }, true);
            }
        },
        getBmi(weight) {
            if (weight) {
                return (weight / (this.height / 100 * this.height / 100)).toFixed(1);
            } else {
                return 0;
            }
        },
        getBmiLevel(num) {
            if (num <= 0) {
                this.selectBmiLevel = ''
            } else if (num < 18.5) {
                this.selectBmiLevel = this.$t('weight.level0')
                this.barLeft = num / 18.5 * this.ratio * 78 - this.ratio * 7;
            } else if (num <= 23.9) {
                this.selectBmiLevel = this.$t('weight.level1')
                this.barLeft = (num - 18.5) / 5.4 * this.ratio * 78 + 78 * this.ratio - this.ratio * 7;
            } else if (num <= 29.9) {
                this.selectBmiLevel = this.$t('weight.level2')
                this.barLeft = (num - 23.9) / 5.9 * this.ratio * 78 + 78 * this.ratio * 2 - this.ratio * 7;
            } else {
                this.selectBmiLevel = this.$t('weight.level3')
                if (num > 40) {
                    this.barLeft = (78 * 4 - 7) * this.ratio;
                } else {
                    this.barLeft = (num - 30) / 10 * this.ratio * 78 + 78 * this.ratio * 3 - this.ratio * 7;
                }
            }
        },
        openSet() {
            this.showSet = true
        },
        onConfirm(values, indexs) {
            console.log(values, indexs);
            this.$api.status.uploadWeight({
                date: getToday(),
                weight: values[0]+'.'+values[1]
            }).then(res => {
                this.showSet = false;
                this.getData();
                WebJSBridge.call("updateWeight", {
                    'weight': values[0]+'.'+values[1]
                }, function (res) {
                });
            })
        },
        onConfirmHeight(value) {
            this.$api.status.uploadHeight({
                height: value
            }).then(res => {
                this.showHeightSet = false;
                this.getData();
                WebJSBridge.call("updateHeight", {
                    'height': value
                }, function (res) {
                });
            })
        }
    },
}
</script>

<style scoped>

#chart-box {
    height: 198px;
    width: 100%;
}

.time-type-select {
    width: 39px;
    height: 22px;
    background-color: var(--bg-color-1);
    border-radius: 4px 4px 4px 4px;
    position: absolute;
    right: 22px;
    color: var(--text-color-1);
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.time-unit-icon {
    width: 9px;
    height: 5px;
    margin-left: 2px;
}

.time-type-box {
    position: absolute;
    right: 22px;
    width: 70px;
    height: 94px;
    box-shadow: 0px 0px 8px 1px rgba(216, 216, 216, 0.5);
    border-radius: 5px 5px 5px 5px;
    background-color: var(--bg-color-2);
    z-index: 1111;
    top: 36px;
    padding: 10px 0 0;
    text-align: left;
}

.time-type-select-en {
    width: 69px;
    right: 5px;
}

.time-type-box-en {
    width: 100px;
    right: 10px;
}

.time-type-item {
    height: 30px;
    color: var(--text-color-1);
    font-size: 15px;
    line-height: 22px;
    margin-left: 18px;
}

.time-check-icon {
    width: 22px;
    vertical-align: bottom;
    margin-left: 5px;
}

.math-box {
    width: 345px;
    height: 72px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 15px auto 10px;
}

.math-item {
    text-align: center;
    margin-top: 11px;
}

.math-num {
    font-family: PP;
    font-size: 23px;
    line-height: 32px;
    color: var(--text-color-1);
}

.math-text {
    font-size: 13px;
    color: var(--text-color-2);
}

.legend-box {
    width: 100%;
    height: 30px;
    position: relative;
}

.legend-bar {
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
}

.legend-bar1 {
    background-color: var(--chart-color-5);
    left: 41px;
    top: 4px;
}

.legend-bar2 {
    background-color: var(--chart-color-3);
    left: 133px;
    top: 4px;
}

.legend-bar3 {
    background-color: var(--chart-color-8);
    left: 224px;
    top: 4px;
}

.legend-bar4 {
    background-color: var(--chart-color-14);
    left: 314px;
    top: 4px;
}

.legend-text {
    position: absolute;
    font-size: 13px;
    color: var(--text-color-2);
}

.legend-text1 {
    top: 0;
    left: 54px;
}

.legend-text2 {
    top: 0;
    left: 146px;
}

.legend-text3 {
    top: 0;
    left: 237px;
}

.legend-text4 {
    top: 0;
    left: 327px;
}

.day-ratio-box {
    width: 345px;
    min-height: 142px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 10px auto;
}

#ratio-chart {
    width: 100px;
    height: 100px;
    margin: 21px auto;
}

.ratio-list {
    width: 100%;
    height: 100%;
}

.first-list {
    margin-top: 12px;
}

.list-item {
    width: 117px;
    height: 27px;
    background: var(--bg-color-1);
    border-radius: 5px 5px 5px 5px;
    margin-bottom: 4px;
    margin-left: 21px;
}

.list-item-key {
    font-size: 13px;
    color: var(--chart-color-14);
    line-height: 27px;
    float: left;
    margin-left: 9px;
}

.list-item-value {
    font-size: 17px;
    font-family: PP;
    color: var(--text-color-1);
    float: right;
    line-height: 27px;
    margin-right: 12px;
}

.last-item {
    margin-bottom: 11px;
}

.color1 {
    color: var(--chart-color-14);
}

.color2 {
    color: var(--chart-color-8);
}

.color3 {
    color: var(--chart-color-5);
}

.color4 {
    color: var(--chart-color-3);
}

.set-icon {
    width: 22px;
    height: 22px;
    margin: 11px 15px;
    float: right;
}

.chart-unit {
    position: absolute;
    font-size: 12px;
    color: var(--text-color-3);
    left: 20px;
    top: 20px;
}

.bmi-box {
    width: 345px;
    height: 118px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin-top: 15px;
    margin-left: 15px;
    position: relative;
}

.bim-title {
    font-family: PP;
    font-size: 13px;
    color: var(--text-color-1);
    width: 36px;
    height: 24px;
    background: var(--bg-color-1);
    border-radius: 5px 5px 5px 5px;
    text-align: center;
    position: absolute;
    left: 15px;
    top: 14px;
    padding-top: 4px;
}

.bim-value-box {
    padding-top: 46px;
    margin-left: 17px;
}

.bim-value {
    font-size: 22px;
    color: var(--text-color-1);
    font-family: PP;
}

.bim-level {
    font-size: 15px;
}

.level0 {
    color: var(--chart-color-24);
}

.level1 {
    color: var(--chart-color-1);
}

.level2 {
    color: var(--chart-color-5);
}

.level3 {
    color: var(--chart-color-3);
}

.bim-process-box {
    font-size: 0;
    margin-left: 17px;
    margin-top: 9px;
    position: relative;
}

.bim-process-bar {
    width: 78px;
    height: 10px;
    border-radius: 5px 5px 5px 5px;
    display: inline-block;
    margin: 0px;
}

.bar0 {
    background-color: var(--chart-color-24);
}

.bar1 {
    background-color: var(--chart-color-1);
}

.bar2 {
    background-color: var(--chart-color-5);
}

.bar3 {
    background-color: var(--chart-color-3);
}

.bar-icon {
    width: 14px;
    height: 20px;
    position: absolute;
    top: -5px;
    left: 0;
}

/deep/ .van-picker__toolbar {
    height: 57px;
}

/deep/ .van-picker__title {
    color: var(--text-color-1);
    font-size: 17px;
}

/deep/ .van-picker__confirm {
    color: var(--chart-color-8);
    font-size: 17px;
}

/deep/ .van-picker__cancel {
    font-size: 17px;
    color: var(--text-color-2);
}

.bim-height {
    height: 26px;
    background: var(--bg-color-1);
    border-radius: 13px 13px 13px 13px;
    font-size: 13px;
    float: right;
    color:var(--text-color-1);
    position: absolute;
    right: 12px;
    top: 14px;
    line-height: 26px;
}

.height-icon {
    width: 18px;
    height: 18px;
    padding: 4px 4px 4px 8px;
    vertical-align: bottom;
}

.height-value {
    font-size: 15px;
    font-weight: 500;
    padding-right: 9px;
}

/deep/ .van-picker {
    background-color: var(--bg-color-2);
    color: var(--text-color-1);
}

/deep/ .van-picker__mask {
    background-image: none;
}

/deep/ .van-picker-column__item {
    color: var(--text-color-1);
}
</style>



// WEBPACK FOOTER //
// src/views/status/20weight.vue